export default __webpack_public_path__ + "static/logo-nova-farma-b416528b0c433b5e8e65dacb1271e352.svg";